/*
 *
 * ReportHome constants
 *
 */

export const GET_STATUS_WATCHER = "app/ReportHome/GET_STATUS_WATCHER"
export const GET_STATUS_SUCCESS = "app/ReportHome/GET_STATUS_SUCCESS"
export const GET_STATUS_FAILED = "app/ReportHome/GET_STATUS_FAILED"

export const GET_DIVISIONS_WATCHER = "app/ReportHome/GET_DIVISIONS_WATCHER"
export const GET_DIVISIONS_SUCCESS = "app/ReportHome/GET_DIVISIONS_SUCCESS"
export const GET_DIVISIONS_FAILED = "app/ReportHome/GET_DIVISIONS_FAILED"

export const GET_DIMENSIONS_WATCHER = "app/ReportHome/GET_DIMENSIONS_WATCHER"
export const GET_DIMENSIONS_SUCCESS = "app/ReportHome/GET_DIMENSIONS_SUCCESS"
export const GET_DIMENSIONS_FAILED = "app/ReportHome/GET_DIMENSIONS_FAILED"

export const GET_QUALITATIVE_WATCHER = "app/ReportHome/GET_QUALITATIVE_WATCHER"
export const GET_QUALITATIVE_QUESTIONS_WATCHER = "app/ReportHome/GET_QUALITATIVE_QUESTIONS_WATCHER"
export const GET_QUALITATIVE_QUESTIONS_SUCCESS = "app/ReportHome/GET_QUALITATIVE_QUESTIONS_SUCCESS"
export const GET_QUALITATIVE_QUESTIONS_FAILED = "app/ReportHome/GET_QUALITATIVE_QUESTIONS_FAILED"
export const GET_QUALITATIVE_SUCCESS = "app/ReportHome/GET_QUALITATIVE_SUCCESS"
export const GET_QUALITATIVE_FAILED = "app/ReportHome/GET_QUALITATIVE_FAILED"

export const GET_MULTIPLE_WATCHER = "app/ReportHome/GET_MULTIPLE_WATCHER"
export const GET_MULTIPLE_SUCCESS = "app/ReportHome/GET_MULTIPLE_SUCCESS"
export const GET_MULTIPLE_FAILED = "app/ReportHome/GET_MULTIPLE_FAILED"

export const GET_TEAMS_WATCHER = "app/ReportHome/GET_TEAMS_WATCHER"
export const GET_TEAMS_SUCCESS = "app/ReportHome/GET_TEAMS_SUCCESS"
export const GET_TEAMS_FAILED = "app/ReportHome/GET_TEAMS_FAILED"

export const GET_RANKS_WATCHER = "app/ReportHome/GET_RANKS_WATCHER"
export const GET_RANKS_SUCCESS = "app/ReportHome/GET_RANKS_SUCCESS"
export const GET_RANKS_FAILED = "app/ReportHome/GET_RANKS_FAILED"

export const GET_MEASURE_INFO_WATCHER =
  "app/ReportHome/GET_MEASURE_INFO_WATCHER"
export const GET_MEASURE_INFO_SUCCESS =
  "app/ReportHome/GET_MEASURE_INFO_SUCCESS"
export const GET_MEASURE_INFO_FAILED = "app/ReportHome/GET_MEASURE_INFO_FAILED"

export const GET_MEASURE_COLOR_RANGE_WATCHER =
  "app/ReportHome/GET_MEASURE_COLOR_RANGE_WATCHER"
export const GET_MEASURE_COLOR_RANGE_SUCCESS =
  "app/ReportHome/GET_MEASURE_COLOR_RANGE_SUCCESS"

export const GET_MULTIPLE_CHOICE_QUESTION_WATCHER =
  "app/ReportHome/GET_MULTIPLE_CHOICE_QUESTION_WATCHER"
export const GET_MULTIPLE_CHOICE_QUESTION_SUCCESS =
  "app/ReportHome/GET_MULTIPLE_CHOICE_QUESTION_SUCCESS"
export const GET_MULTIPLE_CHOICE_QUESTION_FAILED =
  "app/ReportHome/GET_MULTIPLE_CHOICE_QUESTION_FAILED"

export const REFETCH_SENTIMENT_WORDCLOUD_WATCHER =
  "app/ReportHome/REFETCH_SENTIMENT_WORDCLOUD_WATCHER"

export const DOWNLOAD_SENTIMENT_WORDCLOUD_WATCHER =
  "app/ReportHome/DOWNLOAD_SENTIMENT_WORDCLOUD_WATCHER"
